/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.1",
    versionName: "0.7.1",
    versionChannel: "stable",
    buildDate: "2026-10-07T18:57:54.930Z",
    commitHash: "89a7049965f3090e706265670df309a5128233ac",
};
